import { render, staticRenderFns } from "./post-footer.vue?vue&type=template&id=c5c7e062&lang=pug&"
import script from "./post-footer.vue?vue&type=script&lang=js&"
export * from "./post-footer.vue?vue&type=script&lang=js&"
import style0 from "./post-footer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports